// src/data/bsmData.js
// Strictly Verified Official Exchange Baselines (Ground Truth NSE / BSE Figures)
// and Structured Academic Data for Brilliant Share Market Academy

export const OFFICIAL_BENCHMARKS = [
  {
    symbol: 'NIFTY 50',
    subtitle: 'NSE Benchmark',
    price: 22620.45,
    change: -159.75,
    pct: -0.70,
    up: false,
    high: 22809.35,
    low: 22595.20,
    sparkline: [22780, 22750, 22690, 22630, 22610, 22620.45],
    tickFlash: null,
  },
  {
    symbol: 'BANK NIFTY',
    subtitle: 'Banking Index',
    price: 54633.05,
    change: 161.45,
    pct: 0.30,
    up: true,
    high: 55135.50,
    low: 54174.30,
    sparkline: [54471, 54590, 54520, 54700, 54660, 54633.05],
    tickFlash: null,
  },
  {
    symbol: 'FINNIFTY',
    subtitle: 'Financial Services',
    price: 24180.50,
    change: -59.50,
    pct: -0.25,
    up: false,
    high: 24310.00,
    low: 24110.00,
    sparkline: [24240, 24210, 24190, 24170, 24185, 24180.50],
    tickFlash: null,
  },
  {
    symbol: 'SENSEX',
    subtitle: 'BSE Benchmark',
    price: 72480.29,
    change: -291.41,
    pct: -0.40,
    up: false,
    high: 73062.23,
    low: 72366.44,
    sparkline: [72771, 72680, 72590, 72520, 72490, 72480.29],
    tickFlash: null,
  },
];

export const OFFICIAL_GAINERS = [
  {
    symbol: 'RELIANCE',
    company: 'Reliance Industries',
    price: 1187.00,
    change: 5.00,
    pct: 0.42,
    up: true,
    volume: '8.4M',
    sparkline: [1182, 1186, 1190, 1185, 1188, 1187.00],
    tickFlash: null,
  },
  {
    symbol: 'TCS',
    company: 'Tata Consultancy',
    price: 2050.60,
    change: 18.20,
    pct: 0.90,
    up: true,
    volume: '2.8M',
    sparkline: [2032, 2042, 2045, 2042, 2048, 2050.60],
    tickFlash: null,
  },
  {
    symbol: 'HDFCBANK',
    company: 'HDFC Bank Ltd',
    price: 708.70,
    change: -14.00,
    pct: -1.94,
    up: false,
    volume: '14.2M',
    sparkline: [722, 718, 715, 712, 710, 708.70],
    tickFlash: null,
  },
  {
    symbol: 'BHARTIARTL',
    company: 'Bharti Airtel',
    price: 1757.00,
    change: -14.20,
    pct: -0.80,
    up: false,
    volume: '3.7M',
    sparkline: [1771, 1768, 1764, 1760, 1755, 1757.00],
    tickFlash: null,
  },
];

export const OFFICIAL_TICKERS = [
  { symbol: 'NIFTY 50', price: 22620.45, change: -159.75, pct: -0.70, up: false },
  { symbol: 'BANK NIFTY', price: 54633.05, change: 161.45, pct: 0.30, up: true },
  { symbol: 'SENSEX', price: 72480.29, change: -291.41, pct: -0.40, up: false },
  { symbol: 'FINNIFTY', price: 24180.50, change: -59.50, pct: -0.25, up: false },
  { symbol: 'RELIANCE', price: 1187.00, change: 5.00, pct: 0.42, up: true },
  { symbol: 'TCS', price: 2050.60, change: 18.20, pct: 0.90, up: true },
  { symbol: 'HDFCBANK', price: 708.70, change: -14.00, pct: -1.94, up: false },
  { symbol: 'BHARTIARTL', price: 1757.00, change: -14.20, pct: -0.80, up: false },
  { symbol: 'INFY', price: 994.10, change: -21.30, pct: -2.10, up: false },
];

export const PILLARS_DATA = [
  {
    id: 'nism',
    colorClass: 'gold',
    iconType: 'GraduationCapIcon',
    title: 'NISM Series VIII Certified Mentors',
    desc: 'Learn directly from seasoned practitioners with 10+ years of institutional trading and wealth management experience in Indian equity & derivatives.',
    points: ['Active full-time market practitioners', 'Verified track records & trade journals'],
  },
  {
    id: 'live',
    colorClass: 'emerald',
    iconType: 'LaptopIcon',
    title: '100% Live Market Hours Practice',
    desc: 'Theory alone never makes a trader. Trade live alongside faculty during NSE/BSE market hours (9:15 AM - 3:30 PM) to master real-time execution.',
    points: ['Real-time order placement & depth analysis', 'Live volatility and momentum trading'],
  },
  {
    id: 'risk',
    colorClass: 'sapphire',
    iconType: 'ShieldCheckIcon',
    title: 'Mathematical Risk Discipline',
    desc: 'Capital preservation is the cornerstone of our curriculum. Master mandatory 2% position sizing, R:R calculation, and stop-loss automation.',
    points: ['Risk-to-reward setups ≥ 1:2.5', 'Drawdown & emotional psychology control'],
  },
  {
    id: 'campus',
    colorClass: 'cyan',
    iconType: 'HandshakeIcon',
    title: 'Pune Classroom & Live Online',
    desc: 'Attend physical classes at our state-of-the-art Pimpri-Chinchwad center or join live interactive batches online from anywhere across India.',
    points: ['Recorded session backup for lifetime revision', 'Sunday market prep & doubt clearing rooms'],
  },
];

export const COURSES_DATA = [
  {
    id: 'beginner',
    levelTag: 'LEVEL 1 • FOUNDATION',
    targetTag: 'COMPLETE BEGINNER',
    title: "Beginner's Stock Market Course",
    tagline: 'Stock Market Fundamentals & Price Action Basics',
    summary: 'Designed for salaried employees, students, and beginners. Master demat operations, reading candlestick charts, and selecting quality stocks without confusion.',
    duration: '3 Weeks (15 Live Sessions)',
    mode: 'Classroom & Online',
    image: '/assets/bsm_fundamentals.jpg',
    imageAlt: 'Stock Market Fundamentals Study Desk',
    imageTag: 'Level 1 • Foundation',
    featured: false,
    curriculum: [
      'Primary vs Secondary Markets, Demat & Clearing Operations',
      'Candlestick Anatomy: Marubozu, Hammer, Doji, Engulfing',
      'Support & Resistance, Trendlines & Breakout Identification',
      'Order Types: Market, Limit, SL, SL-M & Trailing Orders',
    ],
  },
  {
    id: 'swing',
    levelTag: 'LEVEL 2 • WEALTH CREATION',
    targetTag: 'PART-TIME INVESTOR',
    title: 'Swing Master (Power of Equity)',
    tagline: 'High-Probability Momentum & Breakout Swing Trading',
    summary: 'Perfect for working professionals. Learn to scan multibagger stocks, execute 1:3 risk-reward setups, and generate consistent secondary income with just 30 mins a day.',
    duration: '4 Weeks (20 Live Sessions)',
    mode: 'Classroom & Online',
    image: '/assets/bsm_swing_trading.jpg',
    imageAlt: 'Swing Trading Momentum Setup',
    imageTag: 'Level 2 • Most Popular',
    featured: true,
    curriculum: [
      'Multibagger Equity Screener & Sector Rotation Strategy',
      'Classical Chart Patterns: Cup & Handle, Flags, Double Bottom',
      'Moving Averages (20, 50, 200 EMA) & RSI Divergence Setups',
      'Position Sizing Framework for 1:3 R:R Capital Growth',
    ],
  },
  {
    id: 'master',
    levelTag: 'LEVEL 3 • ADVANCED F&O',
    targetTag: 'FULL-TIME TRADER',
    title: 'Master Course (Full-Time Trader)',
    tagline: 'Futures & Options, Option Greeks & Psychology',
    summary: 'For active intraday traders and serious aspirants. Decode live option chains, master Greeks, execute scalping strategies, and build professional emotional discipline.',
    duration: '6 Weeks (30 Live Sessions)',
    mode: 'Classroom & Online',
    image: '/assets/bsm_fno_derivatives.jpg',
    imageAlt: 'Derivatives & Options Trading Terminal',
    imageTag: 'Level 3 • Advanced',
    featured: false,
    curriculum: [
      'Option Greeks: Delta, Theta Decay, Gamma Blasts & Vega',
      'Live Option Chain Decoding & Open Interest (OI) Analysis',
      'Index Intraday Scalping (NIFTY & BANK NIFTY Setups)',
      'Hedging Frameworks (Straddles, Stangles, Iron Condor)',
    ],
  },
];

export const SCHEDULE_DATA = [
  {
    id: 'weekend',
    cohort: 'Weekend Intensive Cohort',
    sub: 'Beginner • Swing Master',
    startDate: 'Saturday, 11th Oct',
    timings: '10:00 AM – 1:00 PM (Sat & Sun)',
    mode: 'Pune Classroom & Online',
    modeType: 'classroom',
    seatsText: '3 Seats Left',
    seatsAlert: true,
    courseTitle: 'Weekend Intensive Cohort',
  },
  {
    id: 'intraday',
    cohort: 'Live Market Intraday Lab',
    sub: 'Master Course • F&O Intraday',
    startDate: 'Monday, 6th Oct',
    timings: '9:15 AM – 11:30 AM (Mon – Fri)',
    mode: 'Pune Center Classroom',
    modeType: 'classroom',
    seatsText: '4 Seats Left',
    seatsAlert: true,
    courseTitle: 'Live Market Intraday Lab',
  },
  {
    id: 'evening',
    cohort: 'Weekday Evening Batch',
    sub: 'Working Professionals Batch',
    startDate: 'Monday, 13th Oct',
    timings: '7:30 PM – 9:30 PM (Mon – Thu)',
    mode: 'Live Online via Zoom',
    modeType: 'online',
    seatsText: '6 Seats Left',
    seatsAlert: false,
    courseTitle: 'Weekday Evening Batch',
  },
];

export const REVIEWS_DATA = [
  {
    quote: 'I was losing money blindly following Telegram tip channels. Brilliant Academy taught me how to read real price action and why stop-loss is non-negotiable. My portfolio is now in consistent profit with swing trades.',
    name: 'Sagar Jadhav',
    role: 'Software Engineer • Hinjewadi IT Park',
    batch: 'Swing Master Batch 2024',
    initials: 'SJ',
  },
  {
    quote: 'As someone with zero finance background, I was intimidated by stock market terms. The faculty explains everything in simple Marathi and Hindi with live screen demos. The 1-on-1 doubt clearing is priceless.',
    name: 'Pooja Kulkarni',
    role: 'Homemaker & Active Investor • Chinchwad',
    batch: 'Beginner Foundation Batch',
    initials: 'PK',
  },
  {
    quote: 'Master Course F&O decoded option Greeks and open interest like no one else. Sitting on the live market floor during expiry days gave me the conviction to scalp NIFTY without emotional panic.',
    name: 'Rohit Patil',
    role: 'Business Owner • Pimpri',
    batch: 'Master F&O Batch',
    initials: 'RP',
  },
  {
    quote: 'Best trading academy in PCMC. They don\'t sell fake dreams or ask you to invest in dubious apps. Pure technical education, proper position sizing, and lifetime community mentorship.',
    name: 'Amol Shinde',
    role: 'Mechanical Engineer • Bhosari MIDC',
    batch: 'Full-Time Trader Program',
    initials: 'AS',
  },
];

export const FAQS_DATA = [
  {
    category: 'admissions',
    q: 'Do I need a mathematics, finance, or commerce background to join?',
    a: 'Absolutely not. Over 70% of our successful alumni come from engineering, IT, healthcare, small business, and homemaking backgrounds. We start with demat basics and market terminology in plain language before moving into charts.',
  },
  {
    category: 'admissions',
    q: 'What is the batch size at the Pimpri-Chinchwad classroom?',
    a: 'We strictly cap every offline cohort to 15 students. This ensures that every learner gets direct workstation space on the live trading floor and individual mentor guidance during live trading hours.',
  },
  {
    category: 'curriculum',
    q: 'What happens if I miss a scheduled class or trading session?',
    a: 'Every session is backed up with high-definition video recordings accessible inside your student dashboard. You also have the flexibility to attend that topic in the next subsequent batch without paying extra fees.',
  },
  {
    category: 'curriculum',
    q: 'Do you provide stock tips, advisory calls, or calls on Telegram?',
    a: 'No. Brilliant Share Market Academy is an educational institution. We strictly adhere to SEBI regulatory principles. Our sole objective is to empower you to become a self-reliant trader who makes data-driven decisions.',
  },
  {
    category: 'live_floor',
    q: 'Is practical trading done with real money during the course?',
    a: 'Yes. Students practice with disciplined micro-capital (1–2 shares) on live charts to experience real emotions while mathematically restricting monetary risk. No student is allowed to trade large size until their trading journal passes review.',
  },
  {
    category: 'support',
    q: 'How does lifetime mentorship and doubt clearing work?',
    a: 'Once you graduate from any of our 3 programs, you receive permanent access to our alumni community, weekly Sunday market prep webinars, and invitation to sit at the Pune center trading desk for review sessions.',
  },
];

// Market session calculation (IST 9:15 AM - 3:30 PM Mon-Fri)
export function getMarketSession() {
  const now = new Date();
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  const ist = new Date(utc + (3600000 * 5.5));
  const day = ist.getDay();
  const hour = ist.getHours();
  const min = ist.getMinutes();
  const timeMins = hour * 60 + min;
  const isOpen = (day >= 1 && day <= 5) && (timeMins >= 555 && timeMins <= 930);

  let nextSessionStr = '';
  if (!isOpen) {
    let target = new Date(ist);
    if (day === 6) target.setDate(target.getDate() + 2);
    else if (day === 0) target.setDate(target.getDate() + 1);
    else if (timeMins > 930) target.setDate(target.getDate() + (day === 5 ? 3 : 1));
    target.setHours(9, 15, 0, 0);
    const diff = Math.max(0, target.getTime() - ist.getTime());
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    nextSessionStr = `${h}h ${m}m`;
  }

  return {
    isOpen,
    nextSessionStr,
    statusLabel: isOpen ? 'NSE/BSE LIVE' : 'NSE SESSION CLOSED',
    subtext: isOpen ? 'Regular Trading Hours' : `Next Bell in ${nextSessionStr}`,
  };
}
